import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal, message } from 'antd';
import HTTP from '../../../script/service';
import './bindBank.scss';
import jxCaptchaVerifiedHOC from '../../jxCaptchaVerifiedHOC';
import Util from '../../../script/util';

const myreg = /^[1][3-9][0-9]{9}$/;
class BindBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      accountType: 1, //支付宝=1 银行卡=3
      time: 0, //验证码时间
      param: {}, //提现参数
    };
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
    this.setState = () => {
      return;
    };
  }

  showModal = () => {
    this.setState(
      {
        visible: true,
        loading: false,
        xieyi: false,
        poundage: 0,
        time: 0,
      },
      () => {
        this.changeAccountType(3);
      }
    );
  };
  hideModal = () => {
    this.setState(
      {
        visible: false,
      },
      () => {
        this.props.refresh && this.props.refresh();
      }
    );

    this.props.destroyCaptchaVerified();
  };
  //提现方式
  changeAccountType = (n) => {
    const { param } = this.state;
    param['accountNo'] = '';
    param['accountPhone'] = '';
    param['code'] = '';
    param['money'] = '';
    this.setState({
      param: param,
      accountType: n,
      loading: false,
      poundage: null,
    });
  };
  changeFormValue = (e) => {
    let { param } = this.state;
    param[e.target.name] = e.target.value;
    this.setState({
      param: param,
    });
  };
  //发送验证码
  sendCode = async () => {
    const { initCaptchaVerified, getCaptchaVerified, resetCaptchaVerified } =
      this.props;
    const { time, param } = this.state;
    if (time) return false;
    if (!myreg.test(param.accountPhone)) {
      message.warning('请正确填写手机号码');
      return false;
    }
    if (getCaptchaVerified()) {
      // 重新获取验证码需要重置验证码
      resetCaptchaVerified();
      await Util.sleep(300);
    }
    initCaptchaVerified({ phone: param.accountPhone, nationCode: '' }, () => {
      const geeValidate = getCaptchaVerified();
      HTTP._send_code({
        phone: param.accountPhone,
        clientIp: '127.0.0.1',
        type: 2,
        ...geeValidate,
      }).then((res) => {
        if (res.code == 200) {
          this.setState({ time: 60 }, () => {
            this.changeCodeTime();
          });
        } else {
          message.error(res?.message ?? '验证码发送失败，请稍后重试');

          if (res?.code === 5502) {
            resetCaptchaVerified();
            this.sendCode();
          }
        }
      });
    });
  };
  //改变时间
  changeCodeTime = () => {
    let { visible, time } = this.state;
    if (!visible) return;
    clearTimeout(this.timer);
    if (time <= 0) return;
    this.setState({ time: time - 1 }, () => {
      this.timer = setTimeout(this.changeCodeTime, 1000);
    });
  };
  //提现提交
  formSave = () => {
    const { getCaptchaVerified, resetCaptchaVerified } = this.props;
    const { param } = this.state;
    if (!param.accountNo) {
      message.warning(
        this.state.accountType == 1 ? '请填写支付宝账号' : '请填写银行卡号'
      );
      return false;
    }
    if (!param.accountPhone || !myreg.test(param.accountPhone)) {
      message.warning('请填写验证手机号');
      return false;
    }
    if (!param.code) {
      message.warning('请填写验证码');
      return false;
    }
    const ps = {
      uid: this.props.base.uid,
      accountPhone: param.accountPhone,
      code: param.code.trim(),
      accountType: this.state.accountType,
      accountNo: param.accountNo.trim(),
    };
    if (!getCaptchaVerified()) {
      message.warning('请重新获取验证码');
      return;
    }
    this.setState({ loading: true }, () => {
      const geeValidate = getCaptchaVerified();
      HTTP._set_Withdraw({ ...ps, ...geeValidate })
        .then((res) => {
          if (res?.code === 200) {
            message.success('绑定提现账户成功');
            this.hideModal();
          } else {
            message.error(res?.message ?? '操作失败，请稍后重试~');
            if (res?.code === 5502) {
              // 验证码失效，重新获取
              resetCaptchaVerified();
            }
          }
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };

  render() {
    const { visible, accountType, param } = this.state;
    const { user } = this.props;
    return (
      <span>
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title="绑定提现账户"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="700px"
          onCancel={this.hideModal}
        >
          <div className="bind-bank-plan">
            {user ? (
              <span>
                {/* todo 2.22.0 隐藏提现方式 */}
                {/*<div className="form-row">
                  <label className="form-label">提现方式：</label>
                  <div className="form-control">
                     todo 2.4.4.1 需求隐藏支付宝
                    <span
                      style={{ display: 'none' }}
                      className={accountType === 1 ? "tab active" : "tab"}
                      onClick={this.changeAccountType.bind(this, 1)}
                    >
                      支付宝
                    </span>
                    <span
                      className={accountType === 3 ? "tab active" : "tab"}
                      onClick={this.changeAccountType.bind(this, 3)}
                    >
                      银行卡
                    </span>
                  </div>
                </div>*/}
                <div className="form-row">
                  <div className="form-label">持卡人：</div>
                  <div className="form-control">
                    <span className="label-text">
                      {user.userCertVo.realName}
                    </span>
                  </div>
                </div>
                <div className="form-row">
                  {accountType === 1 ? (
                    <label className="form-label">支付宝：</label>
                  ) : (
                    <label className="form-label">银行卡号：</label>
                  )}
                  <div className="form-control">
                    <input
                      type="text"
                      name="accountNo"
                      placeholder={
                        this.state.accountType == 1
                          ? '请填写支付宝账号'
                          : '请填写银行卡号'
                      }
                      value={param.accountNo || ''}
                      onChange={this.changeFormValue}
                      autoComplete="off"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <label className="form-label">手机验证：</label>
                  <div className="form-control">
                    <input
                      type="text"
                      placeholder="请填写验证手机号"
                      name="accountPhone"
                      value={param.accountPhone || ''}
                      onChange={this.changeFormValue}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <label className="form-label">短信验证：</label>
                  <div className="form-control">
                    <input
                      type="text"
                      placeholder="请填写手机短信验证码"
                      maxLength="6"
                      name="code"
                      value={param.code || ''}
                      onChange={this.changeFormValue}
                      autoComplete="off"
                      className="verified-code"
                    />
                    <button
                      className="send-code"
                      disabled={this.state.time > 0}
                      onClick={this.sendCode}
                    >
                      {this.state.time ? `${this.state.time}s` : '发送验证码'}
                    </button>
                  </div>
                </div>
                <div className="form-row">
                  <label className="form-label warn">
                    提现账号的身份信息需与实名认证信息保持一致
                  </label>
                </div>
                <div className="form-row">
                  <label className="form-label">&nbsp;</label>
                  <div className="form-control">
                    <div className="action">
                      <button
                        className="daidai-btn-primary"
                        onClick={this.formSave}
                      >
                        确定
                      </button>
                    </div>
                  </div>
                </div>
              </span>
            ) : null}
          </div>
        </Modal>
      </span>
    );
  }
}

export default jxCaptchaVerifiedHOC(withRouter(BindBank, { withRef: true }));
